import pushEvent from '../pushEvent';
import getEventObjects from './getEventObjects';

const handleDocumentOnEvent = async (win, args, selector, handler) => {
	const eventObjectsToPush = [];
	const eventObjects = await getEventObjects(handler, args);
	eventObjects.forEach((eventObject) => {
		eventObjectsToPush.push(eventObject);
	});

	eventObjectsToPush.forEach((eventObject) => {
		pushEvent(win, eventObject);
	});
};

export default handleDocumentOnEvent;
